import { getApi, postApi } from "@/run";

// телефон пользователя хранится на сервере 11 цифрами (7XXXXXXXXXX,
// ЛК_УчЗапись.ТелефонМенеджера) — в формах он в маске +7 (###) ###-##-##
const maskPhone = (digits) => {
  const d = String(digits || "").replace(/\D/g, "");
  if (d.length !== 11) return "";
  return `+7 (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7, 9)}-${d.slice(9, 11)}`;
};

export const mainModule = {
  state: {
    menu: false,
    loading: true,
    root: false,
    newUser: false,
    companies: [],
    companyId: null,
    bdOpen: false,
    email: null,
    pm: [],
    notificationTotal: 0,
    notification: false,
    notificationRead: null,

    authException: null,
    certificat: {},

    // ФИО, телефон и одобренный лимит пользователя (из /main) — для форм заявок
    fio: "",
    phone: null,
    limit: 0,
    // лимит известен: пришёл в /main (новый GitLkApi) или загружен из /index
    limitLoaded: false,
    profileLoaded: false,
  },
  getters: {
    getLoading(state) {
      return state.loading;
    },
    getRoot(state) {
      return state.root;
    },
    getNewUser(state) {
      return state.newUser;
    },
    getCompanies(state) {
      return state.companies;
    },
    getCompanyId(state) {
      return state.companyId;
    },
    getCompany(state) {
      return state.companies.find((item) => item.id === state.companyId);
    },
    getEmail(state) {
      return state.email;
    },
    getFio(state) {
      return state.fio;
    },
    // телефон в маске формы либо "" (не указан)
    getPhoneMasked(state) {
      return maskPhone(state.phone);
    },
    // одобренный лимит, ₽ (0 — лимита нет)
    getLimit(state) {
      return state.limit;
    },
    getProfileLoaded(state) {
      return state.profileLoaded;
    },
    getPm(state) {
      return state.pm;
    },
    getBdOpen(state) {
      return state.bdOpen;
    },
    getNotificationTotal(state) {
      return state.notificationTotal;
    },
    getNotification(state) {
      return state.notification;
    },
    getNotificationRead(state) {
      return state.notificationRead;
    },
  },
  mutations: {
    setMenu(state, data) {
      state.menu = data;
    },
    setRoot(state, data) {
      state.root = data;
    },
    setNewUser(state, data) {
      state.newUser = data;
    },
    setLoading(state, data) {
      state.loading = data;
    },
    setNotificationTotal(state, data) {
      state.notificationTotal = data;
    },
    setNotification(state, data) {
      state.notification = data;
    },
    setNotificationRead(state, data) {
      state.notificationRead = data;
    },
    setData(state, data) {
      state.root = data.status;
      state.companies = data.companies;
      state.companyId = data.companyId;
      state.email = data.email;
      state.bdOpen = data.bdOpen;
      state.pm = data.pm;
      state.notificationTotal = data.notificationTotal;
      state.notification = data.notification;
      state.eva = data.eva;
      // ФИО, телефон и лимит есть только в ответе /main. В ответах входа и смены
      // профиля их нет — тогда профиль сбрасывается (мог остаться от прежнего
      // пользователя вкладки) и формы догрузят его через loadProfile
      const hasProfile = "phone" in data || "fio" in data;
      state.fio = hasProfile ? data.fio || "" : "";
      state.phone = hasProfile ? data.phone || null : null;
      state.profileLoaded = hasProfile;
      // лимит — только если сервер его прислал; иначе неизвестен и формы
      // догрузят его через loadLimit
      state.limit = "limit" in data ? Number(data.limit) || 0 : 0;
      state.limitLoaded = "limit" in data;
    },
    setAuthException(state, authException) {
      state.authException = authException;
    },
    // профиль из ответа /main (loadProfile)
    setProfile(state, data) {
      state.fio = data.fio || "";
      state.phone = data.phone || null;
      state.profileLoaded = true;
      if ("limit" in data) {
        state.limit = Number(data.limit) || 0;
        state.limitLoaded = true;
      }
    },
    // лимит из /index (главная уже его загрузила, либо loadLimit)
    setLimit(state, limit) {
      state.limit = Number(limit) || 0;
      state.limitLoaded = true;
    },
    setPhone(state, phone) {
      state.phone = String(phone || "").replace(/\D/g, "") || null;
    },
    setCertificat(state, certificat) {
      state.certificat = certificat;
    },
  },
  actions: {
    // профиль для форм: если /main при загрузке не вызывался (вход, смена
    // профиля) — догружаем один раз
    async loadProfile({ state, commit }) {
      if (state.profileLoaded) return;
      const response = await postApi("/main", {});
      if (response && response.status) commit("setProfile", response);
    },
    // лимит для форм на любой странице: если /main его не прислал (GitLkApi
    // без поля limit) и главная ещё не открывалась — берём из /index, как блок
    // лимита на главной
    async loadLimit({ state, commit }) {
      if (state.limitLoaded) return;
      const response = await getApi("/index", {});
      if (response && response.status) commit("setLimit", response.dicAppliedLimits);
    },
  },
  modules: {},
  namespaced: true,
};
